import { formatShowDate } from '../Jobs/jobsTabs/availabeJobs/jobPositions/formatShowDate';
import { shortZoneLabel } from './shiftTimePresentation';

export interface QuoteEventIdentity {
  name?: string;
  startDate?: string;
  endDate?: string;
  city?: string;
  state?: string;
  IANATimeZone?: string;
  timezone?: string;
}

const calendarDate = (value: unknown) => {
  const date = String(value || '').split('T')[0];
  return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : '';
};

/** Callers supply their existing active rows; historical display rows stay excluded. */
export const quoteEventIdentityFromRows = (
  header: QuoteEventIdentity,
  rows: Array<{ startDate?: unknown; endDate?: unknown }>
): QuoteEventIdentity => {
  const starts = rows.map(row => calendarDate(row.startDate)).filter(Boolean).sort();
  const ends = rows.map(row => calendarDate(row.endDate || row.startDate)).filter(Boolean).sort();
  return {
    ...header,
    startDate: starts[0] || '',
    endDate: ends[ends.length - 1] || ''
  };
};

export const formatQuoteIdentityDates = (identity: QuoteEventIdentity) => {
  const start = calendarDate(identity.startDate);
  const end = calendarDate(identity.endDate);
  if (!start) return end ? formatShowDate(end) : '';
  if (!end || start === end) return formatShowDate(start);
  return `${formatShowDate(start)} – ${formatShowDate(end)}`;
};

export const formatQuoteIdentityLocation = (identity: QuoteEventIdentity) => {
  const place = [identity.city, identity.state].filter(Boolean).join(', ');
  const zone = identity.IANATimeZone || identity.timezone || '';
  const startDate = calendarDate(identity.startDate);
  // Without an event date retain the actual zone rather than guessing today's abbreviation.
  const startZone = zone && startDate ? shortZoneLabel(zone, startDate) : zone;
  const endDate = calendarDate(identity.endDate);
  const endZone = zone && endDate ? shortZoneLabel(zone, endDate) : startZone;
  const label = startZone === endZone ? startZone : `${startZone} / ${endZone}`;
  return [place, label].filter(Boolean).join(' · ');
};
